
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("63tmB", function(module, exports) {

$parcel$export(module.exports, "RovoVideoModal", () => $1fe99b055f75d9da$export$31575bcfa345fe24);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $7ZZxN = parcelRequire("7ZZxN");

var $0cdA8 = parcelRequire("0cdA8");

var $eI5EY = parcelRequire("eI5EY");

var $cPEpP = parcelRequire("cPEpP");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");

var $gd0Sp = parcelRequire("gd0Sp");

var $fCsQI = parcelRequire("fCsQI");


var $2sMTC = parcelRequire("2sMTC");

var $mzoJ7 = parcelRequire("mzoJ7");

var $75eDb = parcelRequire("75eDb");

var $9aY8C = parcelRequire("9aY8C");
const $1fe99b055f75d9da$export$31575bcfa345fe24 = ()=>{
    const [isVideoModalOpen, setIsVideoModalOpen] = (0, $eUqFw.useState)(false);
    const { atlassianAccountId: atlassianAccountId, cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const { loading: loadingProject, data: project } = (0, $cPEpP.useProject)();
    const projectType = (0, $7ZZxN.toProjectType)(project?.type);
    const isGateEnabled = (0, $eI5EY.fg)('rovo_video_player_gate');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        const checkOnboardingSeen = async ()=>{
            const hasSeenRovoOnboarding = await (0, $mzoJ7.getRovoVideoOnboardingHash)(atlassianAccountId);
            const { isRovoEnabled: isRovoEnabled } = await (0, $75eDb.fetchRovoEnablement)(cloudId);
            if (!loadingProject && (0, $9aY8C.isJiraSoftware)(projectType) && isGateEnabled && isRovoEnabled && !hasSeenRovoOnboarding) setIsVideoModalOpen(true);
        };
        checkOnboardingSeen();
    }, [
        atlassianAccountId,
        cloudId,
        isGateEnabled,
        loadingProject,
        projectType
    ]);
    const handleClose = async ()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'rovoVideoModalCloseButton');
        await (0, $mzoJ7.setRovoVideoOnboardingSeen)(atlassianAccountId, 'true');
        setIsVideoModalOpen(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isVideoModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: "rovoVideoModal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $eaa71dfaa7b73f30$export$4c7f6e5080d257bc),
        fallback: "unmount",
        onError: (err)=>{
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: (0, $eaa71dfaa7b73f30$export$4c7f6e5080d257bc),
                action: (0, $eaa71dfaa7b73f30$export$6a238c78062d3b8d)
            }), {
                error: err
            });
        },
        teamName: (0, $eaa71dfaa7b73f30$export$d57b6b390e78d90f),
        packageName: (0, $eaa71dfaa7b73f30$export$b8b9d90f9e5bd72b)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $1fe99b055f75d9da$var$ContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fCsQI.default), {
        onClose: handleClose,
        title: (0, $2sMTC.default).videoModalTitle,
        url: (0, $eaa71dfaa7b73f30$export$e8a2b2bcec07868a)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};
const $1fe99b055f75d9da$var$ContainerStyles = (0, $1ZAYh.xcss)({
    position: 'fixed',
    right: '12px',
    bottom: '12px',
    zIndex: 'modal'
});

});
// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("fCsQI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff05081f11533a73$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bFzGY = parcelRequire("bFzGY");

var $aOw1G = parcelRequire("aOw1G");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $bJERd = parcelRequire("bJERd");

var $b6rR4 = parcelRequire("b6rR4");
const $ff05081f11533a73$var$ContainerStyles = (0, $1ZAYh.xcss)({
    boxShadow: 'elevation.shadow.overlay',
    height: '265px'
});
const $ff05081f11533a73$var$ContainerStylesDocked = (0, $1ZAYh.xcss)({
    boxShadow: 'elevation.shadow.overlay',
    height: '40px'
});
function $ff05081f11533a73$export$2e2bcd8739ae039({ defaultMode: defaultMode = (0, $bJERd.ModalMode).DEFAULT, title: title, url: url, testId: testId, analyticsSource: analyticsSource = 'LUNA_VIDEO_PLAYER_MODAL', width: width = '400px', expandedWidth: expandedWidth = '620px', onClose: onClose, onModeChange: onModeChange }) {
    const [mode, setMode] = (0, $eUqFw.useState)(defaultMode);
    const prevModeRef = (0, $eUqFw.useRef)((0, $bJERd.ModalMode).DEFAULT);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const i18nTitle = formatMessage(title);
    (0, $eUqFw.useEffect)(()=>{
        if (mode !== (0, $bJERd.ModalMode).DOCKED) prevModeRef.current = mode;
    }, [
        mode
    ]);
    const handleModeChange = (newMode)=>{
        setMode(newMode);
        onModeChange?.(newMode);
    };
    (0, $eUqFw.useEffect)(()=>{
        createAnalyticsEvent({
            eventType: 'screen',
            type: 'sendScreenEvent',
            data: {
                source: {
                    analyticsSource: analyticsSource
                },
                action: 'viewed',
                actionSubject: 'modal',
                actionSubjectId: 'lunaVideoModal'
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        analyticsSource
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, mode === (0, $bJERd.ModalMode).EXPANDED ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        shouldCloseOnEscapePress: false,
        shouldCloseOnOverlayClick: false,
        onClose: onClose,
        width: expandedWidth,
        height: 500,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b6rR4.ModalContent), {
        title: i18nTitle,
        mode: mode,
        analyticsSource: analyticsSource,
        onClose: onClose,
        onModeChange: handleModeChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("iframe", {
        width: "100%",
        height: "100%",
        src: url,
        title: i18nTitle,
        allowFullScreen: true,
        frameBorder: "0"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: testId,
        style: {
            width: width
        },
        xcss: mode === (0, $bJERd.ModalMode).DOCKED ? $ff05081f11533a73$var$ContainerStylesDocked : $ff05081f11533a73$var$ContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b6rR4.ModalContent), {
        title: i18nTitle,
        mode: mode,
        analyticsSource: analyticsSource,
        onClose: onClose,
        onModeChange: handleModeChange,
        onPrevModeChange: ()=>handleModeChange(prevModeRef.current)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("iframe", {
        loading: "lazy",
        width: "100%",
        height: "100%",
        src: url,
        title: i18nTitle,
        allowFullScreen: true,
        frameBorder: "0"
    }))));
}

});
parcelRegister("bJERd", function(module, exports) {

$parcel$export(module.exports, "ModalMode", () => $2a95aa42af90a8a3$export$5d6770e5bdfdce3d);
var $2a95aa42af90a8a3$export$5d6770e5bdfdce3d;
(function(ModalMode) {
    ModalMode["DOCKED"] = "docked";
    ModalMode["DEFAULT"] = "default";
    ModalMode["EXPANDED"] = "expanded";
})($2a95aa42af90a8a3$export$5d6770e5bdfdce3d || ($2a95aa42af90a8a3$export$5d6770e5bdfdce3d = {}));

});

parcelRegister("b6rR4", function(module, exports) {

$parcel$export(module.exports, "ModalContent", () => $0631fa2d08a85e11$export$6da19a24bf249f17);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $bJERd = parcelRequire("bJERd");

var $kWHCp = parcelRequire("kWHCp");
const $0631fa2d08a85e11$export$6da19a24bf249f17 = ({ mode: mode, title: title, analyticsSource: analyticsSource, children: children, onClose: onClose, onModeChange: onModeChange, onPrevModeChange: onPrevModeChange })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0631fa2d08a85e11$var$outerBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kWHCp.ModalHeader), {
        title: title,
        mode: mode,
        analyticsSource: analyticsSource,
        onClose: onClose,
        onModeChange: onModeChange,
        onPrevModeChange: onPrevModeChange
    }), mode !== (0, $bJERd.ModalMode).DOCKED && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0631fa2d08a85e11$var$modalBodyStyles
    }, children))));
const $0631fa2d08a85e11$var$modalBodyStyles = (0, $1ZAYh.xcss)({
    flex: '1 1 auto'
});
const $0631fa2d08a85e11$var$outerBoxStyles = (0, $1ZAYh.xcss)({
    borderRadius: '3px',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
});

});
parcelRegister("kWHCp", function(module, exports) {

$parcel$export(module.exports, "ModalHeader", () => $24639208d05439f5$export$f50a68e3694789ee);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bFzGY = parcelRequire("bFzGY");

var $7u4fN = parcelRequire("7u4fN");

var $jWuk1 = parcelRequire("jWuk1");

var $22LS1 = parcelRequire("22LS1");

var $drWMe = parcelRequire("drWMe");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $bJERd = parcelRequire("bJERd");

var $e00LQ = parcelRequire("e00LQ");

var $3hxLL = parcelRequire("3hxLL");
const $24639208d05439f5$export$f50a68e3694789ee = ({ title: title, mode: mode, analyticsSource: analyticsSource, onClose: onClose, onModeChange: onModeChange, onPrevModeChange: onPrevModeChange })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleHeaderClick = ()=>{
        if (mode !== (0, $bJERd.ModalMode).DOCKED) return;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: {
                    analyticsSource: analyticsSource
                },
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'lunaVideoModalHeader'
            }
        }).fire();
        onPrevModeChange?.();
    };
    const handleClose = (e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: {
                    analyticsSource: analyticsSource
                },
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'lunaVideoModalHeaderCloseButton'
            }
        }).fire();
        onClose();
    };
    const handleDockClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: {
                    analyticsSource: analyticsSource
                },
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'lunaVideoModalHeaderDockButton'
            }
        }).fire();
        onModeChange((0, $bJERd.ModalMode).DOCKED);
    };
    const handleExpandClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: {
                    analyticsSource: analyticsSource
                },
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'lunaVideoModalHeaderExpandButton'
            }
        }).fire();
        onModeChange((0, $bJERd.ModalMode).EXPANDED);
    };
    const handleMinimizeClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: {
                    analyticsSource: analyticsSource
                },
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'lunaVideoModalHeaderMinimizeButton'
            }
        }).fire();
        onModeChange((0, $bJERd.ModalMode).DEFAULT);
    };
    const isDocked = mode === (0, $bJERd.ModalMode).DOCKED;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: "luna-video-player-modal.ui.content.header.container",
        onClick: handleHeaderClick,
        xcss: isDocked ? $24639208d05439f5$var$dockedStyles : $24639208d05439f5$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: "luna-video-player-modal.ui.content.header.title",
        xcss: $24639208d05439f5$var$titleStyles
    }, title), mode !== (0, $bJERd.ModalMode).DOCKED && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "luna-video-player-modal.ui.content.header.button-dock",
        spacing: "none",
        label: formatMessage((0, $3hxLL.messages).dock),
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e00LQ.DockIcon), {
            label: "",
            size: "medium",
            primaryColor: `var(--ds-icon, ${(0, $PdmhA.N800)})`
        }),
        onClick: handleDockClick
    }), mode === (0, $bJERd.ModalMode).DEFAULT && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "luna-video-player-modal.ui.content.header.button-expand",
        spacing: "none",
        label: formatMessage((0, $3hxLL.messages).expand),
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($22LS1))), {
            label: "video-player-modal.expand-icon",
            size: "medium",
            primaryColor: `var(--ds-icon, ${(0, $PdmhA.N800)})`
        }),
        onClick: handleExpandClick
    }), mode === (0, $bJERd.ModalMode).EXPANDED && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "luna-video-player-modal.ui.content.header.button-minimize",
        spacing: "none",
        label: formatMessage((0, $3hxLL.messages).minimize),
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($drWMe))), {
            label: "video-player-modal.minimize-icon",
            size: "medium",
            primaryColor: `var(--ds-icon, ${(0, $PdmhA.N800)})`
        }),
        onClick: handleMinimizeClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "luna-video-player-modal.ui.content.header.button-close",
        spacing: "none",
        appearance: "subtle",
        label: formatMessage((0, $3hxLL.messages).close),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            label: "video-player-modal.cross-icon",
            size: "medium",
            primaryColor: `var(--ds-icon, ${(0, $PdmhA.N0)})`
        }),
        onClick: handleClose
    }));
};
const $24639208d05439f5$var$headerStyles = (0, $1ZAYh.xcss)({
    background: `linear-gradient(84.09deg, ${"var(--ds-background-accent-blue-subtler, #CCE0FF)"}, ${"var(--ds-background-accent-purple-subtler, #DFD8FD)"})`,
    height: '40px',
    boxSizing: 'border-box',
    padding: 'space.050',
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100'
});
const $24639208d05439f5$var$dockedStyles = (0, $1ZAYh.xcss)({
    background: `linear-gradient(84.09deg, ${"var(--ds-background-accent-blue-subtler, #CCE0FF)"}, ${"var(--ds-background-accent-purple-subtler, #DFD8FD)"})`,
    height: '40px',
    boxSizing: 'border-box',
    padding: 'space.050',
    display: 'flex',
    alignItems: 'center',
    gap: 'space.100',
    cursor: 'pointer'
});
const $24639208d05439f5$var$titleStyles = (0, $1ZAYh.xcss)({
    fontWeight: 600,
    fontSize: '12px',
    lineHeight: '16px',
    color: 'color.text',
    marginRight: 'auto',
    padding: 'space.100'
});

});
parcelRegister("22LS1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17d0e6b497755428$var$_react = $17d0e6b497755428$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $17d0e6b497755428$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $17d0e6b497755428$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $17d0e6b497755428$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M16.587 6.003H15A1 1 0 0115 4h3.9l.047.001a.975.975 0 01.736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 11-2 0V7.411l-3.309 3.308a.977.977 0 01-1.374-.005l-.032-.032a.976.976 0 01-.005-1.374l3.307-3.305zM7.413 17.997H9A1 1 0 019 20H5.1l-.047-.001a.975.975 0 01-.736-.285l-.032-.032A.977.977 0 014 18.946a1.12 1.12 0 010-.048v-3.896a1 1 0 112 0v1.587l3.309-3.308a.977.977 0 011.374.005l.032.032a.976.976 0 01.005 1.374l-3.307 3.305z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$17d0e6b497755428$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $17d0e6b497755428$var$_default = $17d0e6b497755428$var$MediaServicesActualSizeIcon;
module.exports.default = $17d0e6b497755428$var$_default;

});

parcelRegister("drWMe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9cab63de7a2a3a02$var$_react = $9cab63de7a2a3a02$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9cab63de7a2a3a02$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9cab63de7a2a3a02$var$MediaServicesFitToPageIcon = (props)=>/*#__PURE__*/ $9cab63de7a2a3a02$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M16.413 8.997H18A1 1 0 0118 11h-3.9l-.047-.001a.975.975 0 01-.736-.285l-.032-.032A.977.977 0 0113 9.946a1.12 1.12 0 010-.048V6.002a1 1 0 112 0v1.587l3.309-3.308a.977.977 0 011.374.005l.032.032a.976.976 0 01.005 1.374l-3.307 3.305zm-8.826 6.006H6A1 1 0 016 13h3.9l.047.001a.975.975 0 01.736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 11-2 0v-1.587l-3.309 3.308a.977.977 0 01-1.374-.005l-.032-.032a.976.976 0 01-.005-1.374l3.307-3.305z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$9cab63de7a2a3a02$var$MediaServicesFitToPageIcon.displayName = 'MediaServicesFitToPageIcon';
var $9cab63de7a2a3a02$var$_default = $9cab63de7a2a3a02$var$MediaServicesFitToPageIcon;
module.exports.default = $9cab63de7a2a3a02$var$_default;

});

parcelRegister("e00LQ", function(module, exports) {

$parcel$export(module.exports, "DockIcon", () => $138d3850777f1898$export$d73250f348fbe223);

var $eUqFw = parcelRequire("eUqFw");

var $ce8OV = parcelRequire("ce8OV");
const $138d3850777f1898$export$d73250f348fbe223 = ({ primaryColor: primaryColor, size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ce8OV.default), {
        primaryColor: primaryColor,
        size: size,
        label: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "16",
        height: "2",
        x: "4",
        y: "18",
        fill: "currentColor",
        rx: "1"
    })));

});

parcelRegister("3hxLL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bb4346c6fab95fae$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $bb4346c6fab95fae$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    minimize: {
        id: 'luna.video-player-modal.content.header.minimize',
        defaultMessage: 'Minimize',
        description: 'Tooltip for minimizing a modal'
    },
    dock: {
        id: 'luna.video-player-modal.content.header.dock',
        defaultMessage: 'Dock to bottom',
        description: 'Tooltip for docking modal to the bottom in a smaller view'
    },
    expand: {
        id: 'luna.video-player-modal.content.header.expand',
        defaultMessage: 'Expand',
        description: 'Tooltip for expanding a modal'
    },
    close: {
        id: 'luna.video-player-modal.content.header.close',
        defaultMessage: 'Close',
        description: 'Tooltip for closing a modal'
    }
});

});




const $eaa71dfaa7b73f30$export$b8b9d90f9e5bd72b = 'jiraRovoVideoModal';
const $eaa71dfaa7b73f30$export$d57b6b390e78d90f = 'growth-luna';
const $eaa71dfaa7b73f30$export$6a238c78062d3b8d = 'failed';
const $eaa71dfaa7b73f30$export$4c7f6e5080d257bc = 'jiraRovoVideoModalFeature';
const $eaa71dfaa7b73f30$export$e8a2b2bcec07868a = 'https://www.loom.com/embed/87b5573116d344d3a290d6f79c291176?sid=11dca929-28b0-4405-8421-fe63bb25153e';

parcelRegister("2sMTC", function(module, exports) {

$parcel$export(module.exports, "default", () => $093452e427d18489$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $093452e427d18489$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    videoModalTitle: {
        "id": "rovo-video-modal.video-modal-title",
        "defaultMessage": "Get Started with Rovo!"
    }
});

});

parcelRegister("mzoJ7", function(module, exports) {

$parcel$export(module.exports, "getRovoVideoOnboardingHash", () => $de14e87bbee2e11d$export$7ed5123ac12331e6);
$parcel$export(module.exports, "setRovoVideoOnboardingSeen", () => $de14e87bbee2e11d$export$88c0db0edebd3404);

var $48bs8 = parcelRequire("48bs8");

var $guiFP = parcelRequire("guiFP");

var $6vrw7 = parcelRequire("6vrw7");
const $de14e87bbee2e11d$export$9e35978d27ff337f = 'rovoVideoPlayerSeen';
const $de14e87bbee2e11d$export$7ed5123ac12331e6 = async (accountId)=>{
    try {
        return accountId != null ? (await (0, $48bs8.getUserProperty)((0, $6vrw7.toBaseUrl)(''), accountId, $de14e87bbee2e11d$export$9e35978d27ff337f)).hashId : null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // 404 - property has not been previously set
        if (error.statusCode === 404) return null;
        (0, $guiFP.trackFetchErrors)({
            error: error,
            id: 'rovoUserDismissGet',
            packageName: 'jiraRovoVideoModal'
        });
        throw error;
    }
};
const $de14e87bbee2e11d$export$88c0db0edebd3404 = async (accountId, hashId)=>{
    try {
        if (accountId != null) return await (0, $48bs8.setUserProperties)((0, $6vrw7.toBaseUrl)(''), accountId, $de14e87bbee2e11d$export$9e35978d27ff337f, JSON.stringify({
            hashId: hashId
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.trackFetchErrors)({
            error: error,
            id: 'rovoUserDismissSet',
            packageName: 'jiraRovoVideoModal'
        });
        throw error;
    }
};

});

parcelRegister("75eDb", function(module, exports) {

$parcel$export(module.exports, "fetchRovoEnablement", () => $21b4eabcd048abec$export$827924478ef02c4a);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

const $21b4eabcd048abec$export$827924478ef02c4a = async (cloudId)=>{
    try {
        const response = await (0, $lRmyA.performPostRequest)('/gateway/api/graphql', {
            body: JSON.stringify({
                query: (0, $c41e50d2a5b731d3$export$2b91517d6d5b4365),
                variables: {
                    cloudId: cloudId
                }
            }),
            headers: {
                'content-type': 'application/json'
            }
        });
        // handle GraphQL errors
        if (response.errors) (0, $guiFP.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRovoVideoModal',
                teamName: 'luna-growth'
            },
            error: new Error(`RovoEntitlement Error. ${response.errors.map((error)=>error.message).join('; ')}; IsDataEmpty=${response.data?.jira === null || response.data?.jira === undefined}`),
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            isRovoEnabled: !!response.data?.jira?.isRovoEnabled
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'navigationResource',
                packageName: 'jiraRovoVideoModal',
                teamName: 'luna-growth'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return {
        isRovoEnabled: null
    };
};

});
const $c41e50d2a5b731d3$export$2b91517d6d5b4365 = `
query isRovoEnabledQuery($cloudId: ID!) {
  jira {
    isRovoEnabled(cloudId: $cloudId)@optIn(to: "JiraAtlassianIntelligence")
  }
}
`;


parcelRegister("9aY8C", function(module, exports) {

$parcel$export(module.exports, "isJiraSoftware", () => $63337d69fc03dd1c$export$1810b10f6a208e90);

var $7ZZxN = parcelRequire("7ZZxN");
const $63337d69fc03dd1c$export$1810b10f6a208e90 = (projectType)=>projectType && projectType === (0, $7ZZxN.SOFTWARE_PROJECT);

});



//# sourceMappingURL=async-rovo-video-modal-feature.2dc631cb.js.map
